import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import LinearProgress from '@material-ui/core/LinearProgress';
import { Tooltip } from '@material-ui/core';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';



export const LinearGauge = (props) => {
  let business_percentage = props.SLAresponseData;
  // let business_left_Percentage = 100 - business_percentage;
  let business_time_left = "Time Elapsed:" + props.businessTimeLeft;
  const [progress, setProgress] = React.useState(props.SLAresponseData);
  const [open, setOpen] = React.useState(false);
  // const [tooltip, setTooltip] = React.useState(business_time_left + '/' + "Percentage:" + business_percentage);
  const useStyles = makeStyles({
    root: {
      width: '75%'
    },
    colorPrimary: {
      color: '#00695C'
    }
  });
  const classes = useStyles();



  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const theme = createMuiTheme({
    overrides: {
      // Style sheet name ⚛️
      MuiLinearProgress: {
        // Name of the rule
        barColorPrimary: {
          backgroundColor: '#0F62FE',
        }
        ,
        barColorSecondary: {
          backgroundColor: '#DA1E28',
        },
      },
    },
  });


  useEffect(() => {
    //console.log("linearGauge" + props.SLAresponseData);
  }, [props.SLAresponseData, business_time_left]);

  let tooltip = business_time_left + '/' + "Percentage:" + business_percentage;
  let timeElapsedHours = props.businessTimeLeft && props.businessTimeLeft.substr(0, props.businessTimeLeft.indexOf("Hours")) ? props.businessTimeLeft.substr(0, props.businessTimeLeft.indexOf("Hours")) : 0;
  if (props.businessTimeLeft !== null && props.businessTimeLeft.substring(0, props.businessTimeLeft.indexOf("Hour")) !== "") { 
     timeElapsedHours = props.businessTimeLeft && props.businessTimeLeft.substr(0, props.businessTimeLeft.indexOf("Hour")) ? props.businessTimeLeft.substr(0, props.businessTimeLeft.indexOf("Hour")) : 0;
  }
  let timeElapsedMinutesbySplit =  props.businessTimeLeft.substring(0, props.businessTimeLeft.indexOf("Hour")) !== "" ? props.businessTimeLeft.split("Hour").pop():props.businessTimeLeft.split("Hours").pop();
  timeElapsedMinutesbySplit =  props.businessTimeLeft.substring(0, props.businessTimeLeft.indexOf("Hours")) !== "" ? props.businessTimeLeft.split("Hours").pop():props.businessTimeLeft.split("Hours").pop();
  /* corner cases handled per the response*/
  if (timeElapsedMinutesbySplit.includes("Day") === true){
    timeElapsedMinutesbySplit = props.businessTimeLeft.substring(0, props.businessTimeLeft.indexOf("Day")) !== "" ? props.businessTimeLeft.split("Day").pop():props.businessTimeLeft.split("Day").pop();
  }
  if (timeElapsedMinutesbySplit.includes("Hour") === true){
    timeElapsedMinutesbySplit = props.businessTimeLeft.substring(0, props.businessTimeLeft.indexOf("Hour")) !== "" ? props.businessTimeLeft.split("Hour").pop():props.businessTimeLeft.split("Hour").pop();
  }
  let timeElapsedMinutes = timeElapsedMinutesbySplit && timeElapsedMinutesbySplit.substr(0, props.businessTimeLeft.indexOf("Minutes")) ? timeElapsedMinutesbySplit.substr(0, timeElapsedMinutesbySplit.indexOf("Minutes")) : 0;

  let totalTimeElapsedInMinutes;

  if (props.businessTimeLeft !== null && props.businessTimeLeft.substring(0, props.businessTimeLeft.indexOf("Day")) !== "") {
    timeElapsedHours = props.businessTimeLeft !== null && props.businessTimeLeft.substr(0, props.businessTimeLeft.indexOf("Day")) ? props.businessTimeLeft.substr(0, props.businessTimeLeft.indexOf("Day")) : 0;
    timeElapsedHours = timeElapsedHours * 24;
    let timeElapsedHoursDay = props.businessTimeLeft !== null && props.businessTimeLeft.substr(0, props.businessTimeLeft.indexOf("Hours")) ? props.businessTimeLeft.substr(0, props.businessTimeLeft.indexOf("Hours")) : 0;
    if (timeElapsedHoursDay && timeElapsedHoursDay.split("Day").pop().startsWith("s")){
    timeElapsedHoursDay = timeElapsedHoursDay ? timeElapsedHoursDay.split("Days").pop() : 0;
  }
  else {
    timeElapsedHoursDay = timeElapsedHoursDay ? timeElapsedHoursDay.split("Day").pop() : 0;

  }
    timeElapsedHours = parseInt(timeElapsedHours) + parseInt(timeElapsedHoursDay);

  }
  if (timeElapsedHours) {
    totalTimeElapsedInMinutes = (timeElapsedHours * 60) + timeElapsedMinutes;
    //console.log(totalTimeElapsedInMinutes);
  }
  if (timeElapsedHours < 10) {
    timeElapsedHours = "0" + timeElapsedHours;
    timeElapsedHours = timeElapsedHours ? timeElapsedHours.trim():'';

  }
  else {
    timeElapsedHours = timeElapsedHours;
  }

  if (timeElapsedMinutes < 10) {
    timeElapsedMinutes = "0" + timeElapsedMinutes;
    timeElapsedMinutes = timeElapsedMinutes ? timeElapsedMinutes.trim(): '';
  }
  else {
    timeElapsedMinutes = timeElapsedMinutes;
  }


  let roundOffSLAResponseData = props.SLAresponseData !== "" ? parseFloat(props.SLAresponseData.replace(/,/g, '')) : 0;
  let roundOffSLAResponseDataToInteger = roundOffSLAResponseData.toFixed(0);
  let finalRoundOff = roundOffSLAResponseDataToInteger > 100 ? 100 : props.SLAresponseData;
  let color = finalRoundOff < 75 ? 'primary' : (finalRoundOff > 75) ? 'secondary'
    : '';
  if ((props.SLAresponseData))
    return (
      <>
        <div className={classes.root}>
          <ThemeProvider theme={theme}>
            <Tooltip open={open} onClose={handleClose} onOpen={handleOpen} title={tooltip} arrow>
              <LinearProgress color={color} variant="determinate" value={finalRoundOff} />
            </Tooltip>
          </ThemeProvider>
          {/* {totalTimeElapsedInMinutes} */}

          {timeElapsedHours + " " + ":" + " " + timeElapsedMinutes}
        </div>
      </>
    )
  else
    return false;
}

